<template>
  <a-card :bordered="false" :headStyle="{fontSize:'18px'}">
    <a-form>
      <search-header :col="3">
        <search-list>
          <a-form-item label="标题" v-bind="searchItemLayout">
            <a-input v-model="queryParams.title" placeholder="请输入"></a-input>
          </a-form-item>
          <a-form-item style="margin-left:20px;">
            <a-button type="primary" @click="searchBtn">查询</a-button>
          </a-form-item>
        </search-list>
      </search-header>
    </a-form>
    <a-button style="margin-bottom: 20px;" type="primary" @click="goAddEvent(0)" icon="plus">新建</a-button>
    <custom-paging-dragging-list
      ref="table"
      rowKey="id"
      :columns="columns"
      :queryParams="queryParams"
      :requestPromise="loadPromise"
      @draggable="onDraggable"
    >
      <div slot="indexSlots" slot-scope="rowItem">{{ rowItem.index + 1 }}</div>
      <div slot="dateSlots" slot-scope="rowItem">
        {{ rowItem.record.startDate }}至{{ rowItem.record.endDate }}
      </div>
      <div slot="action" slot-scope="rowItem">
        <a @click="goAddEvent(rowItem.record.id)">编辑</a>
        <a-divider type="vertical"/>
        <a-popconfirm
          title="你确定要删除这行内容吗?"
          @confirm="deleteEvent(rowItem.record)">
          <a>删除</a>
        </a-popconfirm>
      </div>
    </custom-paging-dragging-list>
  </a-card>
</template>

<script>

import searchForm from '@/utils/mixins/searchFormMixins'
import CustomPagingDraggingList from '@/customComponents/CustomPagingDraggingList/CustomPagingDraggingList'

export default {
  name: 'ScenicAreaDynamic',
  mixins: [searchForm],
  components: {
    CustomPagingDraggingList
  },
  data() {
    return {
      queryParams: {},
      loadPromise: params => this.getListPromise(params),
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId,
      columns: [
        {
          title: 'ID',
          dataIndex: 'id',
          width: '80px'
        },
        {
          title: '标题',
          dataIndex: 'title'
        },
        {
          title: '上线时间',
          scopedSlots: { customRender: 'dateSlots' },
          width: '300px'
        },
        {
          title: '状态',
          dataIndex: 'statusStr',
          width: '80px'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '120px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    }
  },
  mounted() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'ContentList', title: '内容列表' },
      { name: 'ContentCategory', title: '内容分类' },
      { name: 'Introduction', title: '景区介绍' },
      { name: 'ScenicAreaDynamic', title: '景区动态' }
    ])
  },
  methods: {
    searchBtn() {
      this.$refs.table.refresh()
    },
    onDraggable(params) {
      let idList = []
      idList = params.dataList.map((item) => {
        return item.id
      })
      let data = {
        pageNum: params.pageNo,
        pageSize: params.pageSize,
        idList: idList,
        merchantId: this.merchantId,
        platformId: this.platformId
      }
      this.getHttpServices().getServerApiService().post('scenic/spot/trend/sort', data)
        .then(res => {
          this.$message.success('排序成功')
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    deleteEvent(record) {
      this.getHttpServices().getServerApiService().post('scenic/spot/trend/delete/' + record.id)
        .then(res => {
          this.$refs.table.refresh(true)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getListPromise(params) {
      params.merchantId = this.merchantId
      params.platformId = this.platformId
      return this.getHttpServices().getServerApiService().post('scenic/spot/trend/list', params)
    },
    goAddEvent(id) {
      let params = {}
      if (id) {
        params.id = id
      }
      this.openNewPage('AddDynamic', params)
    },
    getMemberListPromise(params) {
      return this.getHttpServices().getUserService().post('staff/v2/getStaffList', params)
    },
    getStaffStatus() {
      this.getHttpServices().getUserService()
        .post('staff/v2/getStaffListRequestStatusItem')
        .then(list => {
          this.staffStatusList = list
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    }
  }
}
</script>

<style lang="less" scoped>

</style>